import React, { useState } from 'react'

import { Button, ChevronDown, ChevronUp, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string, number, bool } from 'prop-types'

import Reply from './Reply'

function RepliesList({ replies, isLoggedIn = false }) {
  const [showAllReplies, setShowAllReplies] = useState(false)

  if (replies.length === 0) {
    return null
  }

  const repliesToShow = showAllReplies ? replies : replies.slice(0, 1)

  return (
    <div className="rating__replies">
      {repliesToShow.map((reply) => (
        <Reply key={reply.id} reply={reply} isLoggedIn={isLoggedIn} />
      ))}
      {replies.length > 1 && (
        <Button
          type="ghost"
          className="rating__button"
          onClick={() => setShowAllReplies(!showAllReplies)}
          trailIcon={
            <Icon svgComponent={showAllReplies ? ChevronUp : ChevronDown} size="small" />
          }
        >
          {showAllReplies ? 'Hide replies' : 'View all replies'}
        </Button>
      )}
    </div>
  )
}

RepliesList.propTypes = {
  replies: arrayOf(shape({
    id: number.isRequired,
    userId: number,
    content: string.isRequired,
    updatedAt: string.isRequired,
    username: string.isRequired,
    avatar: shape({
      small: shape({
        url: string,
      }),
    }),
  })).isRequired,
  isLoggedIn: bool,
}

export default RepliesList
